import React from 'react';
import { BriefcaseIcon } from 'lucide-react';
import { kits, kitsCopy } from '../data/kitOffer';
export function KitBonuses() {
  return <section className="w-full bg-white py-14 md:py-20" data-id="element-152" data-mp="1enymlykxlwpz">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-153" data-mp="zxzmhq9tgb7v">
        <header className="mx-auto max-w-3xl text-center" data-id="element-154" data-mp="zvmwcptwmujq">
          <BriefcaseIcon className="mx-auto h-8 w-8 text-blue-600 md:h-10 md:w-10" aria-hidden="true" data-id="element-155" data-mp="14xc9cb0otiag" />
          <h2 className="mt-4 text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-156" data-mp="1sngc6g61xe0e">
            {kitsCopy.title}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-blue-900/70" data-id="element-157" data-mp="1jlql5bg30h35">{kitsCopy.subtitle}</p>
        </header>

        <ul className="mx-auto mt-10 grid max-w-4xl gap-4 md:grid-cols-2 md:gap-5" data-id="element-158" data-mp="1nmitm2h4qhyd">
          {kits.map(kit => <li key={kit.number} className="flex h-full flex-col rounded-2xl bg-white p-6 shadow-sm ring-1 ring-blue-100" data-id="element-159" data-mp="858mr5sxc4dv">
              <div className="flex items-center justify-between gap-3" data-id="element-160" data-mp="1lebs95xxt9e7">
                <span className="text-3xl font-extrabold tracking-tight text-blue-200" data-id="element-161" data-mp="1lgo9thzs9hqq">
                  {kit.number}
                </span>
                <span className="shrink-0 rounded-lg bg-emerald-50 px-2.5 py-1 text-xs font-extrabold uppercase tracking-wide text-emerald-600" data-id="element-162" data-mp="1uficnq3pj4cq">
                  {kitsCopy.badge}
                </span>
              </div>
              <h3 className="mt-3 text-xl font-extrabold leading-snug tracking-tight text-slate-900" data-id="element-163" data-mp="24c4vyagdxncn">
                {kit.title}
              </h3>
              <p className="mt-2 font-semibold text-blue-800" data-id="element-164" data-mp="2e399r6ubr25w">{kit.hook}</p>
              <p className="mt-2 leading-relaxed text-blue-900/75" data-id="element-165" data-mp="2e5bylnjqqp91">{kit.description}</p>
            </li>)}
        </ul>

        <div className="mx-auto mt-8 max-w-2xl text-center" data-id="element-166" data-mp="2n3ny6f2l4xdm">
          <p className="text-lg font-semibold text-slate-900" data-id="element-167" data-mp="2n475z2yiu5dx">{kitsCopy.closing}</p>
          <p className="mt-2 font-bold text-blue-600" data-id="element-168" data-mp="2i65pmpshck65">{kitsCopy.closingNote}</p>
        </div>
      </div>
    </section>;
}